import callApi from "../utils/callApi";
import { ServiceUrl } from "../utils/serviceUrl";

export const _LIST_ELECTIVE = async (searchData = false) => {
  let url = ServiceUrl.STUDENTS.LIST_ELECTIVE;
  return callApi(url, "post", searchData && searchData);
};

export const _LIST_SUBJECT_ELECTIVE = async (searchData = false) => {
  let url = ServiceUrl.STUDENTS.LIST_SUBJECT_ELECTIVE;
  return callApi(url, "post", searchData && searchData);
};

export const _SAVE_ELECTIVE = async (searchData = false) => {
  let url = ServiceUrl.STUDENTS.SAVE_ELECTIVE;
  return callApi(url, "post", searchData && searchData);
};
